/* eslint flowtype/require-valid-file-annotation:0 */

// Please update webapp/app/www-unauth/indexNew.js as well if you are changing this file
const unpackStartArgs = require('app/common/lib/jsonUnpackUtils').unpackStartArgs;

unpackStartArgs();

// eslint-disable-next-line pinterest/no-referencing-p-properties
require('app/www-unauth/Main').default.start(P.startArgs);
